// Modules
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function MatchValues(
  matchTo: string
): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    if (
      !!control.parent &&
      !!control.parent.value &&
      control.value === control.parent.controls[matchTo].value
    )
      return null;
    else return { nomatch: true };
  };
}
